module.exports = __webpack_public_path__ + "res/24-img_back.f0f79e8cb7a3f959c31bc5addf218e4d.png";